// extracted by mini-css-extract-plugin
module.exports = {"Workspace":"Workspace_Workspace__1ahsq"};